import React from 'react';
import ScorecardSchemeLabelActions from 'actions/scorecards/ScorecardSchemeLabelActions';
import connectToStores from 'alt-utils/lib/connectToStores';
import ScorecardSchemeLabelStore from 'stores/scorecards/ScorecardSchemeLabelStore';
import AuthStore from 'stores/AuthStore';
import CardLabelsPage from 'components/pure/admin/CardLabelsPage';
import Loading from 'components/pure/utils/Loading';

class CardLabelsPageContainer extends React.Component {
  componentDidMount() {
    ScorecardSchemeLabelActions.labels();
  }

  static getStores() {
    return [AuthStore, ScorecardSchemeLabelStore];
  }

  static getPropsFromStores() {
    return {
      sessionUser: AuthStore.getState().user,
      labels: ScorecardSchemeLabelStore.getState().labels,
    };
  }

  render() {
    if (this.props.labels.size === 0) return <Loading />;

    return <CardLabelsPage {...this.props} onSave={ScorecardSchemeLabelActions.save} />;
  }
}

export default connectToStores(CardLabelsPageContainer);
